"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerManagerColumnFullScreenProps = exports.HaulerManagerColumnProps = void 0;
const constants_1 = require("utils/constants");
const HaulerManagerColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '250',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler NO',
        width: '220',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_no_1',
        title: 'Vessel No 1',
        width: '140',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_capacity_1',
        title: 'Capacity 1 (Ton)',
        width: '140',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_no_2',
        title: 'Vessel No 2',
        width: '140',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_capacity_2',
        title: 'Capacity 2 (Ton)',
        width: '140',
        filter: 'text'
    },
    {
        show: true,
        field: 'driver',
        title: 'Driver Name',
        width: '225',
        filter: 'text'
    },
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Gate',
        width: '200',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text'
    }
];
exports.HaulerManagerColumnProps = HaulerManagerColumnProps;
const HaulerManagerColumnFullScreenProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '250',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler NO',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_no_1',
        title: 'Vessel No 1',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_capacity_1',
        title: 'Capacity 1 (Ton)',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_no_2',
        title: 'Vessel No 2',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'vessel_capacity_2',
        title: 'Capacity 2 (Ton)',
        width: 'auto',
        filter: 'text'
    },
    {
        show: true,
        field: 'driver',
        title: 'Driver Name',
        width: '150',
        filter: 'text'
    },
    {
        show: true,
        field: 'checkpoint_name',
        title: 'Gate',
        width: '150px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text'
    }
];
exports.HaulerManagerColumnFullScreenProps = HaulerManagerColumnFullScreenProps;
